module.exports = "<div class=\"group-plugin just-padding\" v-if=\"currentGroup !== undefined\">\r\n    <ul class=\"group-list-container list-group\">\r\n        <tree-item ref=\"treeItem\" v-for=\"group in groups\" :group=\"group\" :options=\"options\" :parentGroupCode=\"currentGroup\" />\r\n    </ul>\r\n</div>\r\n<loading-spinner v-else/>"


//////////////////
// WEBPACK FOOTER
// ./src/views/childlist/childList.html
// module id = 15
// module chunks = 0